import { createRootRouteWithContext, redirect as navigate } from '@tanstack/react-router';

import { RootLayout } from '@/layout';
import { wait } from '@/utils/async.ts';

type RouterContext = {
  isAuthenticated: boolean;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  // msal is returning auth result async to their event callback, so we need to wait a bit before redirecting
  beforeLoad: async ({ location: { pathname, href: redirect }, context: { isAuthenticated } }) => {
    if (isAuthenticated && pathname === '/login') {
      await wait(1).then(() => {
        const { searchParams } = new URL(redirect, window.location.origin);

        throw navigate({ to: searchParams.get('redirect') ?? '/' });
      });
    }
  },
  component: RootLayout,
  errorComponent: () => <h3 className='mt-32 text-center text-2xl text-white'>Error Occurred</h3>,
  notFoundComponent: () => (
    <h3 className='mt-32 text-center text-2xl text-white'>Page Not Found</h3>
  ),
});
